interface HistoryItem<H = any, A = any> {
  title?: string,
  data: H,
  action?: A
}
type UndoRedoManagerOptions = {
  getCanUndoRedoCallback?: (canUndo: boolean, canRedo: boolean) => void;
};
class UndoRedoManager<H = any, A = any> {
  private history: HistoryItem<H, A>[] = []
  private currentIndex: number = -1;
  private canUndo = false
  private canRedo = false
  private getCanUndoRedoCallback?: (canUndo: boolean, canRedo: boolean) => void;

  constructor(options?: UndoRedoManagerOptions) {
    if (options?.getCanUndoRedoCallback) {
      this.getCanUndoRedoCallback = options.getCanUndoRedoCallback;
    }
    this.getCanUndoRedo();
  }
  push(data: H, title?: string, action?: A) {
    this.history = this.history.slice(0, this.currentIndex + 1);
    this.history.push({ title, data, action });
    this.currentIndex = this.history.length - 1;
    this.getCanUndoRedo()
  }
  replace(data: H, title?: string, action?: A) {
    if (this.currentIndex >= 0 && this.currentIndex < this.history.length) {
      return this.history[this.currentIndex] = { title, data, action }
    }
  }
  getCurrentState(): H | any {
    if (this.currentIndex >= 0 && this.currentIndex < this.history.length) {
      return this.history[this.currentIndex];
    }
    return null;
  }
  undo(): H | null {
    if (this.currentIndex > 0) {
      this.currentIndex--;
      this.getCanUndoRedo()
      return this.history[this.currentIndex + 1] as any
    }
    this.getCanUndoRedo()
    return null;
  }
  redo(): H | null {
    if (this.currentIndex < this.history.length - 1) {
      this.currentIndex++;
      this.getCanUndoRedo()
      return this.history[this.currentIndex] as any;
    }
    this.getCanUndoRedo()
    return null;
  }
  clear(data: H, title?: string, action?: A) {
    this.history = []
    this.currentIndex = data ? 0 : -1;
    this.getCanUndoRedo();
    this.canRedo = false
    this.canUndo = false
    if (this.getCanUndoRedoCallback) {
      this.getCanUndoRedoCallback(this.canUndo, this.canRedo);
    }
  }
  getCanUndoRedo() {
    const canUndo = this.history.length > 0 && this.currentIndex > 0;
    const canRedo = this.history.length > 0 && this.currentIndex < this.history.length - 1;
    if (this.getCanUndoRedoCallback) {
      if (this.canUndo !== canUndo || this.canRedo !== canRedo) {
        this.getCanUndoRedoCallback(canUndo, canRedo)
        this.canUndo = canUndo
        this.canRedo = canRedo
      }
    }
  }
}
export default UndoRedoManager;
